module.exports = __webpack_public_path__ + "static/media/email_success.fb442d1e.svg";